import { Input } from 'almanac-ui/TextInputField/Input'
import { useState } from 'react'

interface Props {
  initialValue?: string
  onCommit: (value: string) => void
}

export const RenamingInput = ({ initialValue = '', onCommit }: Props) => {
  const [value, setValue] = useState(initialValue)

  return (
    <Input
      name="post title"
      autoFocus
      onBlur={() => onCommit(value)}
      value={value}
      size="lg"
      onChange={(e) => {
        setValue(e.target.value)
      }}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.currentTarget.blur()
        }

        if (e.key === 'Escape') {
          setValue(initialValue)
          e.currentTarget.blur()
          onCommit(value)
        }
      }}
    />
  )
}
